/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.flexpay.create.schedule.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.templates',
  'acme.common.service.validate',
  'acme.common.factory.wizard',
  'acme.common.service.userPreferences'
])

.controller('TemplatesCreateFlexpayCreateScheduleController', ['$scope', '$state', '$timeout', 'ApiService', 'HelpersService', 'TemplatesService', 'CalendarService', 'ValidateService', 'WizardFactory', 'UserPreferencesService', function($scope, $state, $timeout, ApiService, HelpersService, TemplatesService, CalendarService, ValidateService, WizardFactory, UserPreferencesService) {

    $scope.templatesCreateFlexpayCreateSchedule = {

      model: {},

      isIndefinite: false,
      showWeekdays: false,
      startTime: new Date(),
      endTime: new Date(),
      getEth: HelpersService.getEth,
      dateFormats: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
      repeatTypes: TemplatesService.repeatTypes,
      repeatMonthTypes: TemplatesService.repeatMonthTypes,
      flexpayTypes: TemplatesService.flexpay.types,
      getRepeatMonthType: TemplatesService.getRepeatMonthType,
      getFlexpayType: TemplatesService.flexpay.getFlexpayType,
      selectedDiscount: {},
      scheduleHours: [],
      scheduleRepeatMonthType: 'date',
      repeatMonthType: {},
      repeatFrequency: {},
      repeatDays: {
        Su: false,
        M: false,
        Tu: false,
        W: false,
        Th: false,
        F: false,
        Sa: false
      },

      init: function() {
        if ($state.params && $state.params.scheduleId) {
          this.model = TemplatesService.flexpay.getScheduleById($state.params.scheduleId).schedule;
        }else{
          this.model = TemplatesService.flexpay.getNewSchedule().schedule;
        }
        this.initWizard();
        ValidateService.addFieldTests(this.wizard.getStep('schedule').validators);

        if (this.model) {
          this.repeatFrequency = TemplatesService.getScheduleRepeatCycle(this.model);
          this.repeatMonthType = this.getScheduleRepeatMonthType();
          this.scheduleRangeHours = TemplatesService.flexpay.getScheduleRangeHours(this.model);
          if (this.model.effectiveStartTime) {
            this.startTime = CalendarService.parseDate(this.model.effectiveStartTime);
          }else{
            this.startTime = new Date();
          }
          if (this.model.effectiveEndTime) {
            this.endTime = CalendarService.parseDate(this.model.effectiveEndTime);
          }else{
            this.isIndefinite = true;
          }

          this.setRepeatDays(this.model.weekdays);
          $timeout(function() {
            $scope.templatesCreateFlexpayCreateSchedule.setRepeating();
          }, 0);
          //this.checkRepeat();
        }else{
          if ($state.params && $state.params.scheduleId) {
            // No schedule exists but was referenced
            $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule does not exist', callback: function() { window.history.go(-1); } });
          }else{
            // Should never occur but in case they arrive at this state manually we will throw a message
            $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule could not be created' });
          }
        }

        $scope.$on('TemplatesCreateSchedulesCreateController::Save', this.onTemplatesCreateSchedulesCreateControllerSave);
        $scope.$on('$destroy', $scope.$watch('templatesCreateFlexpayCreateSchedule.isIndefinite', this.onIndefiniteUpdate));

        console.log('TemplatesCreateSchedulesCreateTimesController::init');

        this.getDiscounts();
      },

      initWizard: function() {
        var self = $scope.templatesCreateFlexpayCreateSchedule;
        this.wizard = new WizardFactory();
        this.wizard.init({
          name: 'schedule',
          validators: [
            {
              field: 'templates-create-flexpay-create-schedule-times-ends',
              equal: {
                message: 'Invalid end date',
                test: function() {
                  return [true, self.endTime instanceof Date];
                }
              }
            },
            {
              field: 'templates-create-flexpay-create-schedule-times-ends',
              equal: {
                message: 'Invalid start date',
                test: function() {
                  return [true, self.startTime instanceof Date];
                }
              }
            },
            {
              field: 'templates-create-flexpay-create-schedule-times-ends',
              greater: {
                message: 'End date cannot be sooner than start date',
                test: function() {

                  var r = {
                    greater: 1,
                    less: 0
                  };

                  if (self.isIndefinite || (self.repeatFrequency.value === 'never')) {
                    r = {
                      greater: 1,
                      less: 0,
                      equalTo: true
                    };
                  } else {
                    r = {
                      greater: self.endTime ? self.endTime.getTime() : 0,
                      less: self.startTime ? self.startTime.getTime() : 1,
                      equalTo: true
                    };
                  }

                  return r;

                }
              }
            },
            // This is created during initialization
            {
              field: 'templates-create-flexpay-create-schedule-range-0',
              greater: {
                message: 'Hours cannot end before they begin',
                test: function() {
                  return {
                    greater: self.scheduleRangeHours[0].end.getTime(),
                    less: self.scheduleRangeHours[0].start.getTime()
                  };
                }
              }
            }]
        });
      },

      getDiscounts: function() {
        ApiService.discounts.list('v2', HelpersService.getPaginator()).then(this.success.getDiscounts, this.error.getDiscounts);
      },

      addHour: function() {
        this.model.hours.push(TemplatesService.createHour());
        this.scheduleHours.push(TemplatesService.hourToDate(this.model.hours[this.model.hours.length - 1]));
      },

      removeHour: function(index) {
        this.model.hours.splice(index, 1);
        this.scheduleHours.splice(index, 1);
      },

      addRange: function() {

        var index,
            self = this;

        if (!this.model.ranges) {
          this.model.ranges = [];
        }
        this.model.ranges.push(TemplatesService.createRange());
        this.scheduleRangeHours.push({
          end: TemplatesService.hourToDate(this.model.ranges[this.model.ranges.length - 1].end),
          start: TemplatesService.hourToDate(this.model.ranges[this.model.ranges.length - 1].start)
        });

        index = this.scheduleRangeHours.length - 1;

        this.wizard.addValidator('schedule', {
          field: 'templates-create-flexpay-create-schedule-range-' + index,
          greater: {
            message: 'Hours can not end before they begin',
            test: function() {
              return {
                greater: self.scheduleRangeHours[index].start.getTime(),
                less: self.scheduleRangeHours[index].end.getTime(),
                equalTo: true
              };
            }
          }
        });
      },

      removeRange: function(index) {
        this.model.ranges.splice(index, 1);
        this.scheduleRangeHours.splice(index, 1);
        this.wizard.removeValidator('schedule', 'templates-create-flexpay-create-schedule-range-' + index);
      },

      updateScheduleHours: function(index) {

        var d;

        if (this.model.hours[index]) {
          d = new Date(this.scheduleHours[index]);
          this.model.hours[index].hour = parseInt(d.getHours(), 10);
          this.model.hours[index].minutes = parseInt(d.getMinutes(), 10);
        }

      },

      updateScheduleRangeHours: function(index) {

        var ds,
          de;

        if (this.model.range) {
          ds = new Date(this.scheduleRangeHours[index].start);
          de = new Date(this.scheduleRangeHours[index].end);
          this.model.range.start.hour = parseInt(ds.getHours(), 10);
          this.model.range.start.minutes = parseInt(ds.getMinutes(), 10);
          this.model.range.end.hour = parseInt(de.getHours(), 10);
          this.model.range.end.minutes = parseInt(de.getMinutes(), 10);
        }

      },

      getScheduleRepeatMonthType: function() {
        var i, ii,
          r = this.repeatMonthTypes[0];

        for (i=0,ii=this.repeatMonthTypes.length;i<ii;i++) {
          if (this.model.repeatMonthType === this.repeatMonthTypes[i].value) {
            r = this.repeatMonthTypes[i];
            break;
          }
        }

        return r;
      },

      setRepeating: function() {
        console.log('setRepeating', this.repeatFrequency.value, this.scheduleEndTime, this.model.effectiveEndTime, this.isIndefinite);
        this.isRepeating = (this.repeatFrequency.value && this.repeatFrequency.value !== 'never');
        this.model.repeatCycle = this.repeatFrequency.value;
        if (this.model.repeatCycle !== 'never' && !this.model.effectiveEndTime) {
          this.isIndefinite = true;
        }

        if (this.model.repeatCycle === 'day') {
          this.showWeekdays = false;
        }else if (this.model.repeatCycle === 'week') {
          this.showWeekdays = true;
        }else if (this.model.repeatCycle === 'month') {
          if (this.model.monthly instanceof Array && this.model.monthly.length > 0) {
            this.repeatMonthType = this.getRepeatMonthType(this.model.monthly[0]);
            this.showWeekdays = true;
          }else if (this.model.daysOfMonth instanceof Array && this.model.daysOfMonth.length > 0) {
            this.repeatMonthType = this.getRepeatMonthType('date');
            this.showWeekdays = false;
          }
        }

      },

      setRepeatDays: function(days) {
        var day;

        if (days instanceof Array) {
          for (day in this.repeatDays) {
            if (this.repeatDays.hasOwnProperty(day)) {
              this.repeatDays[day] = (days.indexOf(day) !== -1);
            }else{
              this.repeatDays[day] = false;
            }
          }
        }
      },

      getRepeatDays: function() {
        var day,
          days = [];

        for (day in this.repeatDays) {
          if (this.repeatDays.hasOwnProperty(day) && this.repeatDays[day] === true) {
            days.push(day);
          }
        }
        return days;
      },

      isRepeatCycle: function(cycle) {
        return (this.repeatFrequency.value === cycle);
      },

      isRepeatMonthType: function(type) {
        return (this.repeatMonthType.value === type);
      },

      addDayOfMonth: function(index, fieldId) {
        var self = $scope.templatesCreateFlexpayCreateSchedule;
        self.model.daysOfMonth.push(1);
        //next tick
        $timeout(function() {
          self.setInputFocus(self.model.daysOfMonth.length-1, fieldId);
        },0);
      },

      removeDayOfMonth: function(index, fieldId) {
        this.model.daysOfMonth.splice(index, 1);
        //next tick
        $timeout(function() {
          $scope.templatesCreateFlexpayCreateSchedule.setInputFocus(index-1, fieldId);
        },0);
      },

      setInputFocus: function(index, fieldId) {
        var el = $('#' + fieldId + '-' + (index || 0));
        if (el.length) {
          el.get(0).focus();
        }
      },

      checkRepeat: function() {
        var showWeekdays = false,
          sDate;

        if (this.isRepeatCycle('day')) {
          this.model.weekdays = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
          this.model.daysOfMonth = null;
          this.model.monthly = null;
        }else if (this.isRepeatCycle('week')) {
          this.model.monthly = null;
          this.model.daysOfMonth = null;
          showWeekdays = true;
        }else if ((this.isRepeatCycle('month') && (this.repeatMonthType.value !== 'date'))) {
          this.model.monthly = [ this.repeatMonthType.value ];
          this.model.daysOfMonth = null;
          showWeekdays = true;
        }else{
          if (!this.startTime.hasOwnProperty('getDate')) {
            sDate = new Date(this.startTime);
          }
          this.endTime = this.startTime;
          this.model.monthly = null;
          if (!(this.model.daysOfMonth instanceof Array && this.model.length > 0)) {
            this.model.daysOfMonth = [ 1 ];
          }
          this.model.weekdays = [];
        }

        this.showWeekdays = showWeekdays;

        this.setRepeating();
      },

      findDiscount: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.discountCodes.length;i<ii;i++) {
          if (this.discountCodes[i].id === id) {
            r = {
              index: i,
              discount: this.discountCodes[i]
            };
            break;
          }
        }

        return r;
      },

      success: {
        init: function(response) {},
        getDiscounts: function(response) {
          var self = $scope.templatesCreateFlexpayCreateSchedule;
          self.discountCodes = response.data.payload.list;
          self.selectedDiscount = self.findDiscount(self.model.discountId).discount;
        }
      },

      error: {
        init: function(response) {},
        getDiscounts: function(response) {}
      },

      onTemplatesCreateSchedulesCreateControllerSave: function() {
        var self = $scope.templatesCreateFlexpayCreateSchedule;

        if (!self.startTime) {
          if (self.endTime) {
            self.startTime = self.endTime;
          }else{
            self.startTime = new Date();
          }
          self.startTime = new Date(self.startTime.getFullYear(), self.startTime.getMonth(), self.startTime.getDate(), 0, 0, 0);
        }

        self.model.effectiveStartTime = CalendarService.toISO8601(self.startTime);
        self.model.repeatCycle = self.repeatFrequency.value;

        if (self.isIndefinite) {
          self.model.effectiveEndTime = null;
        }else{
          if (self.model.repeatCycle === 'never') {
            self.endTime = new Date(self.startTime.getFullYear(), self.startTime.getMonth(), self.startTime.getDate(), 23, 59, 59);
          }
          self.model.effectiveEndTime = CalendarService.toISO8601(self.endTime);
        }
        // Only assign weekdays when visible
        if (self.showWeekdays) {
          self.model.weekdays = self.getRepeatDays();
        }

        /**
         *
         *  Disabled discount option
         *
         *  if (self.model.type === 'discount' && self.selectedDiscount) {
         *     self.model.discountId = self.selectedDiscount.id;
         *  }else{
         *    self.model.discountId = null;
         *  }
         *
         */

        // Force pay what you wish
        self.model.type = self.getFlexpayType(self.flexpayTypes, 'payWhatYouWish').value;

        TemplatesService.flexpay.setSchedule(self.model);
        TemplatesService.flexpay.verifySchedules();

        self.wizard.validate();
      },

      onIndefiniteUpdate: function(n, o) {
        var self = $scope.templatesCreateFlexpayCreateSchedule;
        if (n) {
          self.model.effectiveEndTime = null;
        }else{
          self.model.effectiveEndTime = CalendarService.toISO8601(self.endTime);
        }
      }
    };

    $scope.templatesCreateFlexpayCreateSchedule.init();

}]);